import React, { useEffect, useState } from 'react';
import { Card, CardContent } from "../ui/card";
import { Loader2 } from 'lucide-react';

const getDailyReadingsUrl = (language: string) => {
  //const today = new Date();  //const formattedDate = today.toISOString().split('T')[0].replace(/-/g, '');    // Map of language codes to their respective URLs
  const urlMap: { [key: string]: string } = {
    'it': 'https://www.chiesacattolica.it/liturgia-del-giorno/',
    'en': `https://bible.usccb.org/bible/readings/`,
    'es': 'https://bible.usccb.org/es/lectura-diaria-biblia',
    'de': 'https://www.katholisch.de/stundenbuch',
    'pt': 'https://voxcatolica.com.br/liturgia-diaria/',
    'pl': 'https://deon.pl/czytania',
    'fr': 'https://www.aelf.org/'
  };

  // Default to French if language not supported
  return urlMap[language] || urlMap['fr'];
};

// Define supported languages
const supportedLanguages = ['it', 'en', 'es', 'de', 'pt', 'fr', 'pl'];

const DailyReadingsRedirect = () => {
  const [language, setLanguage] = useState('');
    useEffect(() => {
    let detectedLang;
    
    // Check if URL path contains language parameter and matches daily-readings or daily-readings-redirect
    const pathSegments = window.location.pathname.split('/').filter(Boolean);
    if (
      pathSegments.length >= 2 &&
      (pathSegments[1] === 'daily-readings' || pathSegments[1] === 'daily-readings-redirect')
    ) {
      detectedLang = pathSegments[0].toLowerCase();
    } else if (
      pathSegments.length >= 1 &&
      (pathSegments[0] === 'daily-readings' || pathSegments[0] === 'daily-readings-redirect')
    ) {
      detectedLang = null;
    }

    // Only fallback to browser language if no language was detected in the URL
    if (!detectedLang) {
      detectedLang = navigator.language.slice(0, 2).toLowerCase();
      if (!supportedLanguages.includes(detectedLang)) {
        detectedLang = 'fr';
      }
    }

    setLanguage(detectedLang);

    // Redirect after a short delay
    const timer = setTimeout(() => {
      // Log for debugging
      console.log('[DailyReadingsRedirect] pathSegments:', pathSegments, 'detectedLang:', detectedLang);
      const url = getDailyReadingsUrl(detectedLang);
      // window.location.href = url; // <-- Commented out for testing
      window.location.href = url;
    }, 1500);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen bg-amber-100 flex items-center justify-center p-4">
      <Card className="w-full max-w-md bg-white">
        <CardContent className="pt-6">
          <div className="flex flex-col items-center space-y-4 text-amber-900">
            <Loader2 className="h-8 w-8 animate-spin" />
            <p className="text-center">
              Redirecting to daily readings...
              {language && (
                <span className="block text-sm mt-2">
                  Detected language: {language.toUpperCase()}
                </span>
              )}
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default DailyReadingsRedirect;
